module.exports = __webpack_public_path__ + "static/img/tu6.fca81b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jobs/tu6.png
// module id = k/tC
// module chunks = 1